var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPandas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.922 0h2.623v18.104h-2.623zm-4.126 12.94h2.623v2.57h-2.623zm0-7.037h2.623v5.446h-2.623zm0 11.197h2.623v5.446h-2.623zm-8.34-11.204h2.622v18.104h-2.623zm4.213 2.559h2.623v2.57h-2.622zm0 4.151h2.623v5.447h-2.622zm0-11.187h2.623v5.446h-2.622z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPandas);
export default __webpack_public_path__ + "static/media/pandas.ee2ae866ec6158a17e75af1faba05229.svg";
export { ForwardRef as ReactComponent };